// shell-sdk/src/guards.js

import { ERROR_CATEGORIES } from "./constants.js";
import { getCapabilities } from "./runtime.js";

export function capabilityError(scope, capability) {
    const err = new Error(`Capability denied: ${capability}`);
    err.code = "CAPABILITY_DENIED";
    err.capability = capability;
    err.category = ERROR_CATEGORIES.CAPABILITY;
    err.scope = scope;
    return err;
}

export function requireCapability(scope, capability) {
    const capabilities = getCapabilities(scope);
    const allowed = !!capabilities?.[capability];

    if (!allowed) {
        throw capabilityError(scope, capability);
    }
}
